var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildURI } from '@hn-front/utils';
var ROSTER_API = {
    group: '/api/teachers/roster/groups/:groupId',
    students: '/api/teachers/roster/groups/:groupId/students',
    modifyStudent: '/api/teachers/roster/groups/:groupId/students/:id',
    recoverStudent: '/api/teachers/roster/groups/:groupId/students/:id/recover',
    assistants: '/api/teachers/roster/groups/:groupId/teacher_assistants',
    deleteAssistant: '/api/teachers/roster/groups/:groupId/teacher_assistants/:id',
    generatePassword: '/api/teachers/roster/groups/:groupId/students/password',
    downloadPasswords: '/reports/roster/pdf?groupId=:groupId',
    printPassword: '/reports/roster-student/pdf?groupId=:groupId&studentId=:id',
};
var getGroupDataUrl = function (groupId) {
    return buildURI(ROSTER_API.group, {
        pathParams: { groupId: groupId },
    });
};
var getStudentsDataUrl = function (groupId) {
    return buildURI(ROSTER_API.students, {
        pathParams: { groupId: groupId },
    });
};
var getDeletedStudentsDataUrl = function (groupId) {
    return buildURI(ROSTER_API.students, {
        pathParams: { groupId: groupId },
        query: { 'filter[deleted]': 1 },
    });
};
var getModifyStudentDataUrl = function (groupId, id) {
    return buildURI(ROSTER_API.modifyStudent, {
        pathParams: { groupId: groupId, id: id },
    });
};
var getRecoverStudentDataUrl = function (groupId, id) {
    return buildURI(ROSTER_API.recoverStudent, {
        pathParams: { groupId: groupId, id: id },
    });
};
var getTeacherAssistantsDataUrl = function (groupId) {
    return buildURI(ROSTER_API.assistants, {
        pathParams: { groupId: groupId },
    });
};
var getDeleteTeacherAssistantDataUrl = function (groupId, id) {
    return buildURI(ROSTER_API.deleteAssistant, {
        pathParams: { groupId: groupId, id: id },
    });
};
var getGeneratePasswordUrl = function (groupId) {
    return buildURI(ROSTER_API.generatePassword, {
        pathParams: { groupId: groupId },
    });
};
export var getPrintStudentUrl = function (groupId, id) {
    return buildURI(ROSTER_API.printPassword, {
        pathParams: { groupId: groupId, id: id },
    });
};
export var getDownloadPasswordsUrl = function (groupId) {
    return buildURI(ROSTER_API.downloadPasswords, {
        pathParams: { groupId: groupId },
    });
};
export var getFetchStudentsProps = function (groupId) {
    var url = getStudentsDataUrl(groupId);
    var params = {
        method: 'GET',
    };
    return { url: url, params: params };
};
export var getFetchDeletedStudentsProps = function (groupId) {
    var url = getDeletedStudentsDataUrl(groupId);
    var params = {
        method: 'GET',
    };
    return { url: url, params: params };
};
export var getAddStudentProps = function (groupId, student) {
    var url = getStudentsDataUrl(groupId);
    var params = {
        method: 'POST',
        body: JSON.stringify(student),
    };
    return { url: url, params: params };
};
export var getEditStudentProps = function (groupId, student) {
    var id = student.id, name = student.name, password = student.password;
    var shouldUpdateName = name !== null;
    var url = getModifyStudentDataUrl(groupId, id);
    var params = {
        method: 'PUT',
        body: JSON.stringify(__assign(__assign({}, (shouldUpdateName && { name: name })), { password: password })),
    };
    return { url: url, params: params };
};
export var getDeleteStudentProps = function (groupId, id) {
    var url = getModifyStudentDataUrl(groupId, id);
    var params = {
        method: 'DELETE',
    };
    return { url: url, params: params };
};
export var getRecoverStudentProps = function (groupId, id) {
    var url = getRecoverStudentDataUrl(groupId, id);
    var params = {
        method: 'PUT',
    };
    return { url: url, params: params };
};
export var getFetchTeacherAssistantsProps = function (groupId) {
    var url = getTeacherAssistantsDataUrl(groupId);
    var params = {
        method: 'GET',
    };
    return { url: url, params: params };
};
export var getInviteTeacherAssistantProps = function (groupId, email) {
    var url = getTeacherAssistantsDataUrl(groupId);
    var params = {
        method: 'POST',
        headers: {
            'content-type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify({
            email: email,
        }),
    };
    return { url: url, params: params };
};
export var getDeleteTeacherAssistantProps = function (groupId, email, id) {
    var url = getDeleteTeacherAssistantDataUrl(groupId, id);
    var params = {
        method: 'DELETE',
        body: JSON.stringify({
            email: email,
        }),
    };
    return { url: url, params: params };
};
export var getGeneratePasswordProps = function (groupId) {
    var url = getGeneratePasswordUrl(groupId);
    var params = {
        method: 'GET',
    };
    return { url: url, params: params };
};
export var getFetchGroupProps = function (groupId) {
    var url = getGroupDataUrl(groupId);
    var params = {
        method: 'GET',
    };
    return { url: url, params: params };
};
export var getEditGroupNameProps = function (groupId, name) {
    var url = getGroupDataUrl(groupId);
    var params = {
        method: 'PUT',
        body: JSON.stringify({
            name: name,
        }),
    };
    return { url: url, params: params };
};
export var getEditGroupLanguageProps = function (groupId, language) {
    var url = getGroupDataUrl(groupId);
    var params = {
        method: 'PUT',
        body: JSON.stringify({
            language: language,
        }),
    };
    return { url: url, params: params };
};
